module.exports = __webpack_public_path__ + "static/media/landscape6.8be83811.jpg";